import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalRendererComponent } from '../../widgets/modal-renderer/modal-renderer.component';
import { SseService } from '../../../api/services/sse.service';
import { FORM_ID } from '../../../helpers/form-id.enum';

@Component({
  selector: 'app-modal-button',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ModalRendererComponent,
  ],
  templateUrl: './modal-button.component.html',
  styleUrl: './modal-button.component.css',
})
export class ModalButtonComponent {
  @Input() buttonResponse: any;
  @Input() btnFields: any;
  @Input() fields: any;
  @Input() isLoading: any;
  @Output() buttonClick = new EventEmitter<void>();
  activeModalContext: any;
  modalTitle: any;
  nodeId: any;
  noRecord: any;
  constructor(private SseService: SseService) {}
  onClick(btn: any) {
    if (this.fields && this.fields.fieldDependencies) {
      const fieldDeps = [
        {
          trigger: 'onClick',
          condition: [
            {
              conditions: [
                {
                  type: 'modal',
                  targetType: 'form',
                  targetValue: FORM_ID.DOMAIN_ADD,
                },
              ],
            },
          ],
        },
      ];
      const onClickDep = fieldDeps.find(
        (dep: any) => dep.trigger === 'onClick'
      );

      if (onClickDep && Array.isArray(onClickDep.condition)) {
        for (const condBlock of onClickDep.condition) {
          const modalCond = condBlock.conditions?.find(
            (c: any) =>
              c.type === 'modal' && c.targetType === 'form' && c.targetValue
          );

          if (modalCond) {
            const modalContext = {
              nodeId: modalCond.targetValue,
              record: 'isNotShow',
            };
            this.nodeId = modalCond.targetValue;
            this.noRecord = modalContext.record;
            this.activeModalContext = modalContext;
            this.SseService.initSSE();
            const modal = document.getElementById('domain_modal');
            if (modal) modal.classList.add('show');
            return;
          }
        }
      }
    } else {
      this.buttonClick.emit(btn);
    }
  }

  closeOnBackdropClick(event: MouseEvent, id: string) {
    const modal = document.getElementById(id);
    if (event.target === modal) {
      this.closeModal();
    }
  }

  closeModal() {
    const modal = document.getElementById('domain_modal');
    if (modal) modal.classList.remove('show');
    this.activeModalContext = null;
  }

  onModalFormSaved(event: any): void {
    if (event?.success) {
      const option = this.activeModalContext?.selectedOption;
      const isSseTrigger = true;

      // ✅ If no next step, just close the modal
      const modal = document.getElementById('domain_modal');
      if (modal) {
        modal.classList.remove('show');
      }
      this.activeModalContext = null;
    }
  }

  /** Function to set the modal title */
  setModalTitle(title: string) {
    this.modalTitle = title;
  }

  @HostListener('document:keydown.escape')
  onEscapeKey() {
    this.closeModal();
  }
}
